import  { useEffect ,useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import eventEmitter from "./eventEmitter";
import SessionExpiryDialog from "../common/SessionExpiryDialog";
import { logUserAuth } from '../../util/newRelicApi';
import userProfileStore from "./UserProfileStore";

const OktaEventListener = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const [isOpen,setIsOpen] = useState(false);
  const { email } = userProfileStore();

  /*useEffect(() => {
  let checking = false;
  
    const check = async () => {
      console.log("checking the session is exist ....")
      if (checking || document.hidden) return;
      checking = true;
      try {
        const session = await oktaAuth.session.get(); // or a light /me endpoint
        if (!session?.status || session.status !== 'ACTIVE') {
          console.log("session is not available .....")
          console.warn("Session is inactive. Logging out...");
          setIsOpen(true);
        }
      } catch {
        await oktaAuth.signOut();
      } finally {
        checking = false;
      }
    };

    const onFocus = () => check();
    const onVis = () => { if (!document.hidden) check(); };

    //window.addEventListener('focus', onFocus);
    //document.addEventListener('visibilitychange', onVis);

    // initial
    //check();

    return () => {
      //window.removeEventListener('focus', onFocus);
      //document.removeEventListener('visibilitychange', onVis);
    };
  }, [oktaAuth]);*/

  useEffect(() => {

    
    const handleAuthStateChange = (newAuthState: any) => {
      //console.log("Auth state changed:");
      if (!newAuthState.isAuthenticated) {
        console.warn("User is logged out or session expired!");
      }
    };

    const handleTokenAdded = (key: any, token: any) => {
      console.log(`New token added: ${key}`, token);
    };

    const handleTokenRemoved = (key: string) => {
      console.log(`Token removed: ${key}`);
    };

    const handleTokenExpired = async (key: string) => {
      console.warn(`Token expired: ${key}`);
      logUserAuth(email,`token expired ${key}`);
      if (!authState?.isAuthenticated) {
        console.warn("User not authenticated. Logging out...");
        logUserAuth(email, "User not authenticated. Logging out...");
        setIsOpen(true);
      }
    };

    const handleTokenError = async (key: string) => {
      console.warn(`Token error: ${key}`);
      logUserAuth(email,`Token error ${key}`);
    };

    const handleTokenRenewal = async (key: string, newToken: any) => {
      console.warn(`Token renewal: ${key}`);
      logUserAuth(email,`Token renewal ${key}`);
    };

    function checkInternetStatus() {
      if (navigator.onLine) {
        console.log("Internet is Online");
        window.location.reload();
      } else {
        console.warn("Internet is Offline");
      }
    }

    const logoutListener = async () => {
      console.warn("Received logout event. Logging out...");
       logUserAuth(email,`Received logout event. Logging out...`);
      await oktaAuth.signOut();
    };

    eventEmitter.on("error", logoutListener);
    // Subscribe to Okta events
    oktaAuth.authStateManager.subscribe(handleAuthStateChange);
    oktaAuth.tokenManager.on("added", handleTokenAdded);
    oktaAuth.tokenManager.on("removed", handleTokenRemoved);
    oktaAuth.tokenManager.on("expired", handleTokenExpired);
    oktaAuth.tokenManager.on("error", handleTokenError);
    oktaAuth.tokenManager.on("renewed", handleTokenRenewal);
    window.addEventListener("online", checkInternetStatus);
    window.addEventListener("offline", checkInternetStatus);

    // Cleanup on unmount
    return () => {
      oktaAuth.authStateManager.unsubscribe(handleAuthStateChange);
      oktaAuth.tokenManager.off("added", handleTokenAdded);
      oktaAuth.tokenManager.off("removed", handleTokenRemoved);
      oktaAuth.tokenManager.off("expired", handleTokenExpired);
      oktaAuth.tokenManager.off("error", handleTokenError);
      oktaAuth.tokenManager.off("renewed", handleTokenRenewal);
      window.removeEventListener("online", checkInternetStatus);
      window.removeEventListener("offline", checkInternetStatus);
      eventEmitter.off("error", logoutListener);
    };
  }, [oktaAuth, authState, email]);

  
  const handleContinue = () => {
    oktaAuth.tokenManager.clear();
    localStorage.clear();
    oktaAuth.signOut(); // Auto logout on token expiration
  }

  return <>
      <SessionExpiryDialog isOpen={isOpen} onClose={()=> setIsOpen(false)} onContinue={handleContinue} ></SessionExpiryDialog>
    </>
};

export default OktaEventListener;
